import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AfterCheckout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const planType = params.get("planType");

    if (planType === "immediate") {
      navigate("/wait");
    } else {
      navigate("/register");
    }
  }, [navigate, location]);

  return <div>リダイレクト中です...</div>;
};

export default AfterCheckout;